import { _get, _put } from "../../../../http";

// porcentaje de ganancia plantel
export const getPorcentajeDeGananciaPlantel = (plantelId) => _get(`/plantel/${plantelId}/porcentajeDeGanancia`);

export const putPorcentajeDeGananciaPlantel = (plantelId, body) =>
  _put(`/plantel/${plantelId}/porcentajeDeGanancia`, body);
